import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { Page, PageHeader } from '../ui'
import { MilitaryHearingLossWebsiteVisitors as WebsiteVisitorsView } from '../components/views/militaryHearingLossView/MilitaryHearingLossWebsiteVisitors/MilitaryHearingLossWebsiteVisitors'

function MilitaryHearingLossWebsiteVisitors() {
    return (
        <div className="home">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader eyebrow="Military Hearing Loss" title="Website Visitors" />
                    <WebsiteVisitorsView />
                </Page>
            </MainView>
        </div>
    )
}

export default MilitaryHearingLossWebsiteVisitors
